import {
  convertToServicepointVendorAddress,
  type ServicepointVendor,
  type ServicepointVendorDto,
} from '~/modules/servicepointvendors/model'

export const convertToServicepointVendor = (servicepoint: ServicepointVendorDto): ServicepointVendor => ({
  ...servicepoint,
  address: convertToServicepointVendorAddress(servicepoint.address),
})
